import { render, staticRenderFns } from "./work_item_children_load_more.vue.js?vue&type=template&id=84928bac&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_children_load_more.vue?vue&type=template&id=84928bac&vue3"
import script from "./work_item_children_load_more.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_children_load_more.vue?vue&type=script&lang=js&vue3"
export * from "./work_item_children_load_more.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_children_load_more.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports